import React from 'react';
import { FaStar, FaWhatsapp } from 'react-icons/fa';

import { formatCurrency } from '../utils/format';

import Button from './Button';

const getInitial = (text) => (text && text.length ? text.charAt(0).toUpperCase() : 'M');

function OfferCard({ offer, isBest = false  }) {
  if (!offer || offer.status !== 'ok') {
    return null;
  }
  const providerName = offer?.provider?.name || 'Entidad financiera';
  const installmentCount = offer?.installmentCount || offer?.maxInstallments || null;
  const installmentAmount = offer?.installmentAmount ?? 0;

  return (
    <div className={`bg-white rounded-4 p-4 mb-4 ${isBest ? 'border-3 border-danger shadow' : 'border-2 border-light shadow-sm'}`}>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
        <div className="d-flex align-items-center gap-3">
          <div className="offer-card__logo d-flex align-items-center justify-content-center fw-bold text-white" style={{width: '120px', height: '60px'}}>
            {offer?.provider?.logoUrl ? (
              <img src={offer.provider.logoUrl} alt={providerName} className="w-100 h-100 object-fit-contain" />
            ) : (
              <span>{getInitial(providerName)}</span>
            )}
          </div>
        </div>
        {isBest && (
          <span className="badge rounded-pill px-3 py-2 fw-semibold d-inline-flex align-items-center gap-2" style={{backgroundColor: 'var(--color-badge-bg)', color: 'var(--color-accent)'}}>
            <FaStar size={14} />
            Mejor opción
          </span>
        )}
      </div>
      <hr/>
      <small className="text-muted">Este es tu monto máximo disponible</small>
      <div className="display-4 fw-bold my-3" style={{color: 'var(--color-text-dark)'}}>{formatCurrency(offer?.maxAmount)}</div>
      {installmentCount && (
        <p className="mb-0 fw-medium" style={{color: 'var(--color-brand-primary)', fontSize: '0.95rem'}}>
          Pagá en <strong>{installmentCount} cuotas.</strong>
        </p>
      )}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4">
        <div className="rounded-2 px-3 py-2 d-inline-flex" style={{backgroundColor: 'var(--color-installment-badge-bg)'}}>
          <small className="fw-medium d-flex align-items-center gap-1" style={{color: 'var(--color-accent)', fontSize: '0.85rem'}}>
            🏷️ Cuota estimada desde <strong className="fw-bold">{formatCurrency(installmentAmount, { decimals: 2 }).replace('ARS', '').trim()}</strong>
          </small>
        </div>
          <Button 
            as="a"
            href="https://wa.me/5491171915132"
            target="_blank"
            rel="noopener noreferrer"
            variant="danger"
            className="px-4  d-inline-flex align-items-center gap-2"
          >
            <FaWhatsapp />
            Quiero saber más
          </Button>
      </div>
    </div>
  );
}

export default OfferCard;
